import { Button as MuiButton, ButtonProps } from '@mui/material'
import isArray from 'lodash/isArray'

import { FCWithChildren } from '@/types'

import { lowerCasePrepositions } from '@/util/string'

const Button: FCWithChildren<
  ButtonProps & { target?: '_blank' | 'self' | 'parent' | 'top' }
> = ({ children, ...props }) => {
  let content = children
  if (
    typeof children === 'string' ||
    (isArray(children) && children.every((child) => typeof child === 'string'))
  ) {
    content = lowerCasePrepositions(
      typeof children === 'string' ? children : children.join(' ')
    )
  }

  return <MuiButton {...props}>{content}</MuiButton>
}

export default Button
